/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the "Elastic License
 * 2.0", the "GNU Affero General Public License v3.0 only", and the "Server Side
 * Public License v 1"; you may not use this file except in compliance with, at
 * your election, the "Elastic License 2.0", the "GNU Affero General Public
 * License v3.0 only", or the "Server Side Public License, v 1".
 */

import { replace } from 'lodash';
import React, { Children } from 'react';
// eslint-disable-next-line no-restricted-imports
import { Switch, useRouteMatch } from 'react-router-dom';
import { Routes as ReactRouterRoutes, Route } from 'react-router-dom-v5-compat';
import { Route as LegacyRoute, MatchPropagator } from './route';
import { SharedUXRoutesContext } from './routes_context';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const Routes = ({
  legacySwitch = true,
  enableExecutionContextTracking = false,
  children
}) => {
  const match = useRouteMatch();
  return legacySwitch ? ___EmotionJSX(SharedUXRoutesContext.Provider, {
    value: {
      enableExecutionContextTracking
    }
  }, ___EmotionJSX(Switch, null, children)) : ___EmotionJSX(SharedUXRoutesContext.Provider, {
    value: {
      enableExecutionContextTracking
    }
  }, ___EmotionJSX(ReactRouterRoutes, null, Children.map(children, child => {
    if (/*#__PURE__*/React.isValidElement(child) && child.type === LegacyRoute) {
      var _child$props;
      const path = replace(child === null || child === void 0 ? void 0 : child.props.path, match.url + '/', '');
      const renderFunction = typeof (child === null || child === void 0 ? void 0 : child.props.children) === 'function' ? child === null || child === void 0 ? void 0 : child.props.children : child === null || child === void 0 ? void 0 : child.props.render;
      return ___EmotionJSX(Route, {
        path: path,
        element: ___EmotionJSX(React.Fragment, null, enableExecutionContextTracking && ___EmotionJSX(MatchPropagator, null), (child === null || child === void 0 ? void 0 : (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.component) && ___EmotionJSX(child.props.component, null) || renderFunction && renderFunction() || children)
      });
    } else {
      return child;
    }
  })));
};